import React from "react";
import ClientDeactivationDialog from "components/ClientDetails/Dialogs/ClientDeactivationDialog";

/**
 * Wrapper component for confirming scheduled deactivation from notifications.
 * This dialog is triggered when clicking a deactivation notification.
 * It uses the unified ClientDeactivationDialog with the "confirm_from_notification" trigger mode.
 */
const NotificationConfirmDeactivationDialog = ({
  open,
  onClose,
  clientId,
  clientName,
}) => {
  return (
    <ClientDeactivationDialog
      open={open}
      onClose={onClose}
      clientId={clientId}
      clientName={clientName}
      triggerMode="confirm_from_notification"
    />
  );
};

export default NotificationConfirmDeactivationDialog;

